import { render, staticRenderFns } from "./AbastecimentosDespesasLancar.vue?vue&type=template&id=08678b37&scoped=true"
import script from "./AbastecimentosDespesasLancar.vue?vue&type=script&lang=js"
export * from "./AbastecimentosDespesasLancar.vue?vue&type=script&lang=js"
import style0 from "./AbastecimentosDespesasLancar.vue?vue&type=style&index=0&id=08678b37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08678b37",
  null
  
)

export default component.exports